var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseMenuMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8037 0.629228L10.8041 0.628866C10.9638 0.46918 11.2205 0.46918 11.3802 0.628866C11.5308 0.779452 11.5308 1.04535 11.3802 1.19594L6.92972 5.64645L6.57617 6L6.92972 6.35355L11.3802 10.8041C11.5399 10.9638 11.5399 11.2205 11.3802 11.3802C11.2205 11.5399 10.9638 11.5399 10.8041 11.3802L6.35355 6.92972L6 6.57617L5.64645 6.92972L1.19594 11.3802C1.03625 11.5399 0.779452 11.5399 0.619765 11.3802C0.460078 11.2205 0.460078 10.9638 0.619765 10.8041L5.07028 6.35355L5.42383 6L5.07028 5.64645L0.619765 1.19594C0.460078 1.03625 0.460078 0.779452 0.619765 0.619765C0.779452 0.460078 1.03625 0.460078 1.19594 0.619765L5.64645 5.07028L5.99964 5.42347L6.35319 5.07064L10.8037 0.629228Z",
    fill: "white",
    stroke: "#4909AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenuMobile);
export default __webpack_public_path__ + "static/media/close-menu-mobile.646924f1026394126dd59e7be95914ae.svg";
export { ForwardRef as ReactComponent };